import PortalPage from './PortalPage';

export default PortalPage;
